import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Auth Guard, that prevents unauthorized access
 */
@Injectable()
export class AuthGuard implements CanActivate {
  /**
   * Constructor
   * @param {Router} router           Router
   * @param {AuthService} authService Authentication service
   */
  constructor(private router: Router, private authService: AuthService) {}

  /**
   * Checks if the user can access the page
   * @returns {boolean} True if user can access the page
   */
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    try {
      // If no auth token is set then...
      if (!route.queryParams['auth-token']) {
        // ...check if user is logged in
        if (this.authService.isLoggedIn()) {
          // If user is logged in
          return true;
        } else {
          // If user is not logged in go to the login page
          this.router.navigate(['login']).then();
          return false;
        }
      } else {
        // If auth token is set, try to login the user with the token
        return await this.authService.loginWithToken(route.queryParams['auth-token']);
      }
    } catch (error) {
      // On error, deny access to the route
      return false;
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/services/auth.guard.ts